export interface CommandDispatcher{
  dispatch(cmd_name,args): Promise<{[key: string]: any} > ;
  dispatch_with_result?(cmd_name,args,sleep_time_ms?): Promise<{[key: string]: any}>;
}

export async function dispatch_and_wait_job(cmd_name, args, dispatcher, jobs, sleep_time_ms = 500) {
  let job_id = (await dispatcher.dispatch(cmd_name,args)).job_id
  let state = 'pending'
  let response = undefined
  while (state=='pending' || state=='draft' || state=='running') {
    response = await jobs.getJob({ id: job_id });
    state = response.data.state;
    if (state=='done')
      return response.data.output_info
    else if (state=='pending' || state=='draft' || state=='running')
      await (new Promise(res => setTimeout(res, sleep_time_ms)))
    else {
      console.error('Ha habido un error job_id:',job_id)
      throw new Error(`Job ${job_id} failed with state: ${state}`)
    }
  }
}